import { FormControlLabel, Grid, InputLabel, Radio, RadioGroup } from '@material-ui/core';
import InspectionImages from '../inspectionCheckImagesModal';
import { useContext } from 'react';
import { InspectionCheCkContaxt } from './InspectionCheckProvide';
import { TextBox } from '../../../../Core/FormInput';

export const InspectionBreakTest = ({ classes }) => {
    const { state, setState, handleInput } = useContext(InspectionCheCkContaxt);
    const isReadOnly = Boolean(state.isDisabled || state.vehicleInspectionInspectorSignature);

    return (
        <Grid item xs={12} style={{ marginBottom: 14 }}>
            <div
                style={{
                    background: '#ffffff',
                    border: '1px solid #e2e8f0',
                    borderRadius: 8,
                    padding: '14px 18px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.02)'
                }}
            >
                <Grid container spacing={3} alignItems="flex-start">
                    {/* Left Column: Brake Test Type, Test Number, & Upload Image */}
                    <Grid item xs={12} lg={6}>
                        <div style={{ marginBottom: 8 }}>
                            <InputLabel shrink style={{ fontWeight: 600, fontSize: 12, color: '#334155', marginBottom: 2 }}>
                                Type of brake test
                            </InputLabel>
                            <RadioGroup
                                row
                                aria-label="vehicleInspectionBrakeTestTypeID"
                                name="vehicleInspectionBrakeTestTypeID"
                                value={+state.vehicleInspectionBrakeTestTypeID}
                                onChange={handleInput}
                            >
                                <FormControlLabel
                                    value={1}
                                    control={<Radio size="small" color="primary" disabled={isReadOnly} />}
                                    label={<span style={{ fontSize: 12, fontWeight: 500, color: isReadOnly ? '#94a3b8' : '#334155' }}>Roller Test</span>}
                                />
                                <FormControlLabel
                                    value={2}
                                    control={<Radio size="small" color="primary" disabled={isReadOnly} />}
                                    label={<span style={{ fontSize: 12, fontWeight: 500, color: isReadOnly ? '#94a3b8' : '#334155' }}>Decelerometer</span>}
                                />
                                <FormControlLabel
                                    value={3}
                                    control={<Radio size="small" color="primary" disabled={isReadOnly} />}
                                    label={<span style={{ fontSize: 12, fontWeight: 500, color: isReadOnly ? '#94a3b8' : '#334155' }}>Road Test</span>}
                                />
                            </RadioGroup>
                        </div>

                        <Grid container spacing={2} alignItems="flex-end">
                            <Grid item xs={12} sm={7}>
                                <InputLabel shrink style={{ fontWeight: 600, fontSize: 12, color: '#334155', marginBottom: 4 }}>
                                    Brake Test Number
                                </InputLabel>
                                <TextBox
                                    margin="none"
                                    disabled={isReadOnly}
                                    placeholder="Brake test number"
                                    name="vehicleInspectionBrakeTestNumber"
                                    value={state.vehicleInspectionBrakeTestNumber}
                                    onChange={handleInput}
                                    InputProps={{
                                        style: {
                                            height: 38,
                                            backgroundColor: '#fff',
                                            fontSize: 12
                                        }
                                    }}
                                    inputProps={{
                                        style: {
                                            padding: '8px 12px',
                                            fontSize: 12
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={5} style={{ display: 'flex', alignItems: 'center', height: '100%', marginTop: -10 }}>
                                <InspectionImages state={state} setState={setState} disabled={isReadOnly} />
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* Right Column: Road Conditions */}
                    <Grid item xs={12} lg={6}>
                        <InputLabel shrink style={{ fontWeight: 600, fontSize: 12, color: '#334155', marginBottom: 4 }}>
                            Road Conditions
                        </InputLabel>
                        <TextBox
                            multiline
                            margin="none"
                            disabled={isReadOnly}
                            placeholder="Road conditions"
                            name="vehicleInspectionRoadCondition"
                            value={state.vehicleInspectionRoadCondition}
                            onChange={handleInput}
                            fullWidth
                            InputProps={{
                                style: {
                                    height: 104,
                                    alignItems: 'flex-start',
                                    backgroundColor: '#fff',
                                    fontSize: 12
                                }
                            }}
                            inputProps={{
                                style: {
                                    height: '100%',
                                    boxSizing: 'border-box',
                                    fontSize: 12
                                }
                            }}
                            style={{
                                height: 104,
                                margin: 0
                            }}
                        />
                    </Grid>
                </Grid>
            </div>
        </Grid>
    );
};

export default InspectionBreakTest;
